import { useState } from "react";

const AdvertiserForm = () => {
  const [formst, setFormst] = useState(""); // 'ok' or 'failed'
  const [showModal, setShowModal] = useState(false);
  const [winPercent, setWinPercent] = useState(0);
  const [discountPercent, setDiscountPercent] = useState(0); // New state for discount percentage

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    targeted_market: "",
    brand_name: "",
    phone: "",
    email: "",
    help_description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://darchasbcontact.pythonanywhere.com/contact/advertiser/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const responseData = await response.json();

      if (response.ok) {
        setFormst("ok");
        setWinPercent(Math.floor(Math.random() * 51) + 50); // 50% - 100%
        setDiscountPercent(responseData.discount_percent); // Set the discount percentage
      } else {
        setFormst("failed");
        setWinPercent(0);
        setDiscountPercent(0);
      }
    } catch (error) {
      setFormst("failed");
      setWinPercent(0);
      setDiscountPercent(0);
    }
    setShowModal(true);
  };

  const fields = [
    { id: "first_name", name: "first_name", label: "نام", placeholder: "نام خود را وارد کنید..." },
    { id: "last_name", name: "last_name", label: "نام خانوادگی", placeholder: "نام خانوادگی خود را وارد کنید..." },
    { id: "targeted_market", name: "targeted_market", label: "حوزه فعالیت", placeholder: "حوزه فعالیت خود را مشخص کنید..." },
    { id: "brand_name", name: "brand_name", label: "نام برند", placeholder: "نام برند خود را وارد کنید..." },
    { id: "phone", name: "phone", label: "شماره تلفن", placeholder: "شماره تلفن خود را وارد کنید..." },
    { id: "email", name: "email", label: "ایمیل", placeholder: "ایمیل خود را وارد کنید...", type: "email" },
    { id: "help_description", name: "help_description", label: "توضیحات", placeholder: "نیاز خود را توضیح دهید..." },
  ];

  return (
    <div className="flex flex-col justify-center items-center py-36">
      <div className="mt-10 text-4xl">دیده شوید</div>
      <div className="font-medium text-gray-400">
        برای دریافت تخفیف، اطلاعات خود را وارد کنید
      </div>

      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-2 gap-10 max-md:mx-5 md:w-[900px] border border-gray-300 p-20 my-10 rounded-3xl bg-white text-right"
      >
        {fields.map(({ id, name, label, placeholder, type }) => (
          <div
            key={id}
            className={`mb-5 max-md:col-span-2 ${
              name === "help_description" ? "col-span-2" : ""
            }`}
          >
            <label
              htmlFor={id}
              className="mb-3 block text-base font-medium text-gray-400 pr-2"
            >
              {label}
            </label>
            <input
              type={type || "text"}
              name={name}
              id={id}
              value={formData[name]}
              onChange={handleChange}
              placeholder={placeholder}
              {...(name !== "help_description" && { required: true })}
              className="w-full border border-gray-300 rounded-xl py-3 px-6 text-base font-medium text-gray-700 outline-none focus:shadow-md text-right"
            />
          </div>
        ))}

        <div className="max-md:col-span-2 col-span-2">
          <button
            type="submit"
            className="w-full hover:shadow-form bg-gray-900 py-4 text-xl font-semibold text-white outline-none rounded-2xl hover:bg-gray-600 transition-all"
          >
            ارسال
          </button>
        </div>
      </form>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-3xl shadow-xl p-10 w-80 text-center">
            <h2
              className={`text-2xl font-bold mb-4 ${
                formst === "ok" ? "text-green-600" : "text-red-600"
              }`}
            >
              {formst === "ok" ? "ارسال موفق بود!" : "خطا در ارسال فرم"}
            </h2>
            {formst === "ok" && (
              <p className="mb-4 text-lg text-gray-700">
                {`شما ${discountPercent}% تخفیف دریافت کردید! 🎉`}
              </p>
            )}
            <button
              onClick={() => setShowModal(false)}
              className="mt-4 bg-gray-900 text-white py-2 px-6 rounded-xl hover:bg-gray-700"
            >
              بستن
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdvertiserForm;
